import { Modal, ModalClose, Sheet } from "@mui/joy";
import React, { useState, useEffect, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";
import ConfirmPopup from "../../../Components/ConfirmPopup";
import { approve } from "../../../config/provider";
import { ethers } from "ethers";
import { checkAllowance } from "../../../config/provider";
import {
  usdtTokenAddress,
  mldTokenAddress,
  metaspaceNFTMarketplaceAddress,
  nftContractABI,
  nftStakingAddress,
} from "../../../config/data";
import axios from "axios";
import { isSupportedNFT } from "../NftMarketPage/contractData";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import CircularLoader from "../../../Components/CircularLoader/CircularLoader";
import {
  isApprovedForAll,
  listNFT,
  setApprovalForAll,
} from "../MyNfts/contractData";
import { convertedMulPrice } from "../../../config/common";
import {
  getRequiredLord,
  nftApprove,
  setStake,
} from "../../Pool/nftContractData";
import {
  gasEstimateListing,
  gasEstimateStake,
} from "../../../config/gasEstimation";
import environmentVariables from "../../../config/environmentVariables";
import TransactionLoader from "../../../Components/TransactionLoader/TransactionLoader";
import { userBalanceContext } from "../../../context/userBalanceContext";
import { userInfoContext } from "../../../context/userInfoContext";
import { toast } from "react-toastify";
import { buyTokenPopUpContext } from "../../../context/buyTokenPopUpContext";
import LowBalancePopUp from "../../../Components/LowBalancePopUp/LowBalancePopUp";
import ComingSoon from "../../../Components/ComingSoon/ComingSoon";
const HashImg = `${environmentVariables?.cdnUrl}HashImg.png`
const CollectionBoxImg = `${environmentVariables?.cdnUrl}mass-effect.gif`
const CollectionBoxImgMelee = `${environmentVariables?.cdnUrl}melee.png`
const CollectionBoxChar     = `${environmentVariables?.cdnUrl}character.png`

const NFTStakeandListPage = ({
  nftloading,
  data,
  allContractDetails,
  name,
  fetchDetails,
}) => {
  const classes = useStyles();
  const params = useParams();
  const triggerPusher = (address) => {
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${environmentVariables?.apiUrl}/nftmarketplace/api/v1/trigger_event`,
      headers: {
        authorization:`Bearer ${userAccInfo}`
      },
      data: {address:address.toLowerCase()},
    };

    axios
      .request(config)
      .then(() => {
        // console.log(JSON.stringify(response.data));
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const [open, setOpen] = React.useState(false);
  const [listingGas, setListingGas] = useState("");
  const [gasStake, setGasStake] = useState(0);
  const [currency, setCurrency] = React.useState("MLD");
  const [isStakeError,setIsStakeError]=React.useState(false);
  const [comingSoonPopup,setComingSoonPopUp] = React.useState(false);
  const [loading, setLoading] = useState(false);
  const [approvePopUP,setApprovePopUp]=useState(false);
  const [approvePopUpForStaking,setApprovePopUpForStaking]=useState(false);
  const [loadingBtn,setLoadingBtn]=useState(false);
  const [loadingList, setLoadingList] = useState(false);
  const [loadingStake, setLoadingStake] = useState(false);
  const { userBalance } = useContext(userBalanceContext);
  const [listBtnDisable,setListBtnDisable]=useState(true);
  const [approveLoading,setApproveLoading]=useState(false);
  const [userBalance1, setUserBalance1] = useState({
    LORDBalance: 0,
    LORD: 0,
    RequiredLord: 0,
  });
  const [message, setMessage] = useState("");
  const [isListStakeError, setIsListStakeError] = useState(false);
  const [stakeConfirmPopup, setStakeConfirmPopup] = useState(false);
  const [listPopUp, setListPopUp] = useState(false);
  const [showCreatedPopup, setShowCreatedPopup] = useState(false);
  const [showDepositPopup, setShowDepositPopup] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [auction, setAuction] = useState(false);
  const [lowBalancePopUp, setLowBalancePopup] = useState(false);
  const [perform, setPerform] = useState("");
  const [apiData, setApiData] = useState(null);

  const { setIsBuyOpen, setPopUpCurrency } = useContext(buyTokenPopUpContext);

  const [price, setPrice] = useState("");
  const [stakeBtnSubmit, setStakeBtnSubmit] = useState(false);
  const [transactionHash, setTransactionHash] = useState(null);
  const [transactionFee, setTransactionFee] = useState(null);
  const [tokenId, setTokenId] = useState("");
  const {userAccInfo}=useContext(userInfoContext)
  const [approveStakingPopUpOpen,setApproveStakingPopUpOpen]=useState(false);
  const [contractAdd, setContractAdd] = useState("");
  const navigation = useNavigate();
  const [allowance, setAllowance] = useState({
    USDT: parseInt(allContractDetails?.usdtMarketPlaceAllowance),
    MLD: parseInt(allContractDetails?.mldMarketPlaceAllowance),
    LORDAllowance: 0,
  });
  const checkApproval=async (contractadd)=>{
    try{
      const nftContract = await getNFTContract(contractadd)
      const getIsApprovedForAll = await isApprovedForAll(nftContract,allContractDetails?.address,metaspaceNFTMarketplaceAddress)
      // console.log(getIsApprovedForAll,'fffffffffffffffflllllllllllllllljjjjjjjjjjjjjj')
      if(getIsApprovedForAll==true){
        setApprovePopUp(false);
        setListBtnDisable(true);
      }else{
        setApprovePopUp(true);
        setListBtnDisable(false)
      }
    }catch(err){
      // console.log(err,'fffffffffffffffflllllllllllllllljjjjjjjjjjjjjj')
      setApprovePopUp(true);
    }
  }

  const checkApprovalForStaking=async (contractadd)=>{
    try{
      const allowanceLord=Number(allowance.LORDAllowance);
      const nftContract=await getNFTContract(contractadd);
      const requiredLord=Number(userBalance1?.RequiredLord);
      const getIsApprovedForAll=await isApprovedForAll(
        nftContract,
        allContractDetails?.address,
        nftStakingAddress
      )
      console.log(allowanceLord,requiredLord,getIsApprovedForAll,getIsApprovedForAll==true,allowanceLord>=requiredLord,'jaosidjadsjdkajhdskjhajkdahdsj')
      if(getIsApprovedForAll==true&&allowanceLord>=requiredLord){
        setApprovePopUpForStaking(false);
      }else{
        setApprovePopUpForStaking(true);
      }
    }catch(err){
      setApprovePopUpForStaking(true);
      console.log(err);
    }
  }
 

  const getCollectionImage = (contract) => {
    if (contract == "0x6ab30d4c7de4a24cbe84eb310fd164b64b06b532") {
      return (
        <>
          <CollectionImg src={CollectionBoxImgMelee}></CollectionImg>
        </>
      );
    } else if (contract == "0x7eb272ac9b9fec60c5a7921ccc075152a961111c") {
      return (
        <>
          {" "}
          <CollectionImg src={CollectionBoxChar}></CollectionImg>
        </>
      );
    } else if (contract == "0x8fc3dec6148a9924870f205617c9c26b3010243e") {
      return (
        <>
          {" "}
          <CollectionImg src={CollectionBoxImg}></CollectionImg>
        </>
      );
    }
  };

  useEffect(() => {
    if (window != undefined) {
      const params = window.location.href.split("/");
      const contractAdd1 = params[params.length - 2];
      const tokenId1 = params[params.length - 1];
      setTokenId(tokenId1);
      setContractAdd(contractAdd1);
      checkApproval(contractAdd1)
      checkApprovalForStaking(contractAdd1)
      axios
        .get(
          `${environmentVariables?.apiUrl}/nftmarketplace/api/v1/get_token_details/${contractAdd1}/${tokenId1}`
        )
        .then((res) => {
          setApiData(res.data);
          setLoading(false);
        })
        .catch((err) => console.log(err));
    }
  }, [userBalance1,allowance]);


  const addInitiatedTransactions = async (contract, token, type) => {
    try {
      let data = {
        type: type,
        user_address: allContractDetails?.address,
        contract_address: contract,
        token_id: token,
      };

      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${environmentVariables?.apiUrl}/nftmarketplace/api/v1/add_initiated_trxs`,
        headers:{
        authorization:`Bearer ${userAccInfo}`
      },
        data: data,
      };

      axios
        .request(config)
        .then(() => {
          // console.log(response.data);
        })
        .catch((error) => {
          console.log(error, "initiated transaction error");
        });
    } catch (err) {
      console.log(err, "initiated transaction error");
    }
  };
  const addErrorLogs = async (type, error) => {
    try {
      let data = {
        type: type,
        error: error,
        user_address: allContractDetails?.address,
      };

      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${environmentVariables?.apiUrl}/nftmarketplace/api/v1/add_error_log`,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };

      axios
        .request(config)
        .then(() => {
          // console.log(response.data);
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (err) {
      console.log(err);
    }
  };
  const getAllTheInformation = async () => {
    setLoading(true);
    const address = allContractDetails?.address;
    // setDefaultAccount(address);

    const lordBal = (await allContractDetails?.lordBal) || 0;
    const requiredLord =
      (await getRequiredLord(allContractDetails?.nftStakingContract)) || 0;

    setUserBalance1({
      LORDBalance: parseInt(lordBal),
      LORD: parseFloat(ethers.formatEther(lordBal)).toFixed(2),
      RequiredLord: parseFloat(ethers.formatEther(requiredLord)).toFixed(
        2
      ),
    });
    // console.log(parseInt(lordBal),parseFloat(ethers.formatEther(lordBal)).toFixed(2),parseFloat(ethers.formatEther(requiredLord)).toFixed(
    //   2
    // ),';;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;')
    setAllowance({
      LORDAllowance: parseInt(
        await checkAllowance(
          allContractDetails?.lordTokenContract,
          address,
          nftStakingAddress
        )
      ),
    });
  };
  useEffect(() => {
    if (data?.tradeCurrency) {
      setCurrency(getTradeCurrency(data?.tradeCurrency));
    }
  }, [data]);

  useEffect(() => {
    if (allContractDetails) {
      getAllTheInformation();
    }
  }, [allContractDetails]);
  const getConvertedCurrency = (currency, updatedPrice) => {
    if (currency == null || currency == undefined) {
      return;
    }
    if (currency.toLowerCase() == "usdt") {
      return parseFloat(Number(updatedPrice) / 1000000);
    } else {
      return parseFloat(Number(updatedPrice) / 1000000000000000000);
    }
  };

  const handleApproveNFTForStaking=async ()=>{
    try{
      setApproveLoading(true)
       if (userBalance?.MATIC < 0.06) {
        setMessage("Insufficient POL");
        setIsListStakeError(true);
        setApproveLoading(false)
        setStakeBtnSubmit(false);
        return;
      }
      const lordBalance=await userBalance?.LORD;
      if(lordBalance<10){
        setIsStakeError(true)
        setStakeBtnSubmit(false)
        setApproveLoading(false)
        setApproveStakingPopUpOpen(false);
        return;
      }
      const allowanceLord = Number(allowance.LORDAllowance);
      const requiredLord = Number(userBalance1.RequiredLord);
      const nftContract = await getNFTContract(contractAdd);
      const getIsApprovedForAll = await isApprovedForAll(
      nftContract,
      allContractDetails?.address,
      nftStakingAddress
      );
      if(getIsApprovedForAll!=true){
        await nftApprove(nftContract,nftStakingAddress,allContractDetails?.provider)
      }
      if(allowanceLord<requiredLord){
        await approve(allContractDetails?.lordTokenContract,nftStakingAddress,allContractDetails?.provider)
      }
      
      await handleStake();
      setApproveLoading(false)
      setApprovePopUpForStaking(false);

    }catch(err){
      console.log(err)
      setApproveLoading(false);
      setMessage("Something went wrong");
      setIsListStakeError(true);
      setApprovePopUpForStaking(false);
    }
  }
  const handleApproveNFT=async ()=>{
    try{
    if (userBalance?.MATIC < 0.05) {
      setMessage("Insufficient POL");
      setIsListStakeError(true);
      setLoadingList(false);
      return;
    }
    
      setApproveLoading(true);
      const nftContract=await getNFTContract(contractAdd);
      // const getIsApprovedForAll=await isApprovedForAll(nftContract,allContractDetails?.address,metaspaceNFTMarketplaceAddress);
      // if(getIsApprovedForAll==true){
      //   setApprovePopUp(false);
      //   setListBtnDisable(true);
      // }else{
      const res=await setApprovalForAll(nftContract,metaspaceNFTMarketplaceAddress,allContractDetails?.provider);
        setApprovePopUp(false);
        setListBtnDisable(true);
        setApproveLoading(false);
      // } 
    }catch(err){
      console.log(err)
      setMessage("Something went wrong");
        setIsListStakeError(true);
        setLoadingBtn(false);
        setLoadingList(false);
        setApproveLoading(false);
    }
  }
  const onConfirmClick = async () => {
    setLoadingList(true);
    setListPopUp(false);
    setListingGas(null)
    if (userBalance?.MATIC < 0.03) {
      setMessage("Insufficient POL");
      setIsListStakeError(true);
      setLoadingList(false);
      return;
    } else if (userBalance?.MATIC < listingGas) {
      setMessage("Insufficient POL");
      setIsListStakeError(true);
      setLoadingList(false);
      return;
    }
    // console.log(price, "--------------------------price----------------------");
    // console.log(fetchDetails, "--------------------------price----------------------");

    // console.log(currency, "--------------------currency--------------------");
    // console.log(
    //   contractAdd,
    //   "-------------------------address-------------------- "
    // );
    if (price > 0 && currency !== "") {
      // console.log("price", price);
      try {
        const nftContract = await getNFTContract(contractAdd);

        // const ownerAddress = await ownerOf(nftContract, tokenId);

        // console.log('ownerAddress', ownerAddress)
        // console.log(' allContractDetails?.address',  allContractDetails?.address)
        // if (ownerAddress === allContractDetails?.address) {
        // console.log("inside if of the owner", nftContract);
        const getIsApprovedForAll = await isApprovedForAll(
          nftContract,
          allContractDetails?.address,
          metaspaceNFTMarketplaceAddress
        );

        // console.log("getIsApprovedForAll", getIsApprovedForAll);
        if (getIsApprovedForAll === true) {
          // console.log("inside if of getIsApprovedForAll is true");
          await callNftListing();
        } else {
          // console.log("inside if of getIsApprovedForAll is false ");
          await setApprovalForAll(nftContract, metaspaceNFTMarketplaceAddress,allContractDetails?.provider);

          await callNftListing();
        }
        // } else {
        //   setLoading(false);
        //   setMessage("you are not a owner user");
        //   setShowCreatedPopup(true);
        // }
      } catch (err) {
        console.log("inside else catch block", err);
        setLoadingList(false);
        setMessage(err?.message || "Something went wrong");
        // setShowCreatedPopup(true);
      }
    } else {
      setLoadingList(false);
      // alert("Please field all fields.");
      toast.warning("please fill all the fields")
      setLoadingList(false);
      setLoadingBtn(false)
    }
  };
  const getNFTContract = async (nftAddress) => {
    return new ethers.Contract(
      nftAddress,
      nftContractABI,
      allContractDetails?.signer
    );
  };
  const stake = async (nftAddress, tokenID) => {
    setLoadingStake(true);
    setStakeConfirmPopup(false);
    const balanceLord = Number(userBalance.LORD);
    const allowanceLord = Number(allowance.LORDAllowance);
    const requiredLord = Number(userBalance1.RequiredLord);
    const nftContract = await getNFTContract(nftAddress);

    const getIsApprovedForAll = await isApprovedForAll(
      nftContract,
      allContractDetails?.address,
      nftStakingAddress
    );

    if (balanceLord >= requiredLord) {
      if (allowanceLord >= requiredLord && getIsApprovedForAll === true) {
        await callStake(nftAddress, tokenID);
      } else {
        if (allowanceLord < requiredLord) {
         await approve(
            allContractDetails?.lordTokenContract,
            nftStakingAddress,
            allContractDetails?.provider
         )  
        }
        if (getIsApprovedForAll !== true) {
          await nftApprove(nftContract, nftStakingAddress,allContractDetails?.provider);
        }
        await callStake(nftAddress, tokenID);
      }
    } else {
      // alert("not enough balance");
      // setIsListStakeError(true);
      // setMessage("Not enough Lords");
      setIsStakeError(true);
      setLoadingStake(false);
    }
  };
  const getNFTOwner=async (contract,tokenId)=>{
    try{
      const nftInformation=await axios.get(`${environmentVariables?.apiUrl}/nftmarketplace/api/v1/testingweb3new/${contract}/${tokenId}`);
      // console.log(nftInformation,'gas--------------------------------------------->')
      if(nftInformation?.data?.owner){
        return nftInformation?.data?.owner;
      }else{
        return null;
      }
    }catch(err){
      console.log("error in getNFTOwner",err);
      addErrorLogs("getNFTOwner",JSON.stringify(err));
      setMessage("Something went wrong, please try again later.");
      setIsListStakeError(true);
      return;
    }
  }
  const handleListNFT = async (e) => {
    if (price && currency) {
      // console.log(price);
      // console.log(newPrice);
      // const nftContract=getNFTContract(contractAdd);
      // await setApprovalForAll(nftContract,metaspaceNFTMarketplaceAddress)
      const gas = await gasEstimateListing(
        contractAdd,
        tokenId,
        currency,
        price,
        auction,
        allContractDetails?.address
      );
      if(isNaN(gas)||gas==null||gas==undefined||gas==0){
        setMessage("Network Busy, please try again after sometime.")
        // setIsListStakeError(true);
        setLoadingBtn(false);
        setLoadingList(false)
        setListBtnDisable(true);
        return;
      }
      if(e.target.value==null||e.target.value==0||e.target.value==undefined){
        setListBtnDisable(true);
      }else if(price==null||price==undefined||price==0){
        setListBtnDisable(true)
      }else{
        setListBtnDisable(false);
      }
      setMessage("");
      setListingGas(gas);
    }
  };
  const handleList = async () => {
    try{
      setMessage("")
      setLoadingBtn(true);
      const nftOwnerInfo=await getNFTOwner(contractAdd,tokenId)
      if(nftOwnerInfo===null){
        setMessage("Something went wrong, please try again later.");
        setIsListStakeError(true);
        setLoadingBtn(false);
        return;
      }else if(nftOwnerInfo?.toLowerCase()!==allContractDetails?.address?.toLowerCase()){
        setMessage("NFT Listing is taking time! Please try again after a few minutes.");
        setIsListStakeError(true);
        setLoadingBtn(false);
        return;
      }
      setListPopUp(true);
    }catch (error) {
      console.log(error);
      setMessage("Something went wrong, please try again later.");
      setIsListStakeError(true);
      setLoadingList(false);
      setLoadingBtn(false);
    }
  }
  const handleStake = async () => {
    try {
      // setComingSoonPopUp(true);
      // setStakeBtnSubmit(false);
      // return;
      setStakeBtnSubmit(true)
      const nftOwnerInfo=await getNFTOwner(contractAdd,tokenId)
      if(nftOwnerInfo===null){
        setMessage("Something went wrong, please try again later.");
        setIsListStakeError(true);
        setStakeBtnSubmit(false);
        setApproveStakingPopUpOpen(false);
        return;
      }else if(nftOwnerInfo?.toLowerCase()!==allContractDetails?.address?.toLowerCase()){
        setMessage("NFT Staking is taking time! Please try again after a few minutes.");
        setIsListStakeError(true);
        setStakeBtnSubmit(false);
        setApproveStakingPopUpOpen(false);
        return;
      }
      if (userBalance?.MATIC < 0.06) {
        setMessage("Insufficient POL");
        setIsListStakeError(true);
        setStakeBtnSubmit(false);
        setApproveStakingPopUpOpen(false);
        return;
      }
      setStakeBtnSubmit(true);
      const lordBalance = await userBalance?.LORD;
      if (lordBalance < 10) {
        // alert("not enough lords");
        // toast.warning("Not enough lords")
        // setMessage("Not enough Lords");
        // setIsListStakeError(true)
        setIsStakeError(true)
        setStakeBtnSubmit(false);
        setApproveStakingPopUpOpen(false);
        return;
      }

      const gasEstStake = await gasEstimateStake(
        contractAdd,
        tokenId,
        allContractDetails?.address
      );
      console.log(gasEstStake,'aksldaksdkajsdjkahsdkjahdjkahsdjkashdasjkdhs')
      if(isNaN(gasEstStake)||gasEstStake==null||gasEstStake==undefined||gasEstStake==0){
        setMessage("Network Busy, please try again later.")
        setIsListStakeError(true)
        setStakeBtnSubmit(false);
        setLoadingList(false)
        setApproveStakingPopUpOpen(false);
        return;
      }
      if (userBalance?.MATIC < gasEstStake) {
        setMessage("Insufficient POL");
        setIsListStakeError(true);
        setLoadingList(false);
        setStakeBtnSubmit(false);
        setApproveStakingPopUpOpen(false);
        return;
      }
      // console.log(gasEstStake, "------------------stakeing gas");
      setGasStake(gasEstStake);
      setStakeConfirmPopup(true);
      setStakeBtnSubmit(false);
      setApproveStakingPopUpOpen(false);
     
    } catch (error) {
      console.log(error);
      setMessage("Something went wrong, please try again later.");
      setIsListStakeError(true);
      setLoadingList(false);
      setStakeBtnSubmit(false);
      setApproveStakingPopUpOpen(false);
    }
  };
  const  callStake = async (nftAddress, tokenID) => {
    await addInitiatedTransactions(nftAddress, tokenID, "stake");
    await setStake(allContractDetails?.nftStakingContract, nftAddress, tokenID,allContractDetails?.provider)
      .then((res) => {
        if (res !== null) {
          console.log(res, "responseafterstaking");
          setTransactionHash(res?.hash || res?.transactionHash);
          setTransactionFee(
            parseFloat(
              (Number(res?.gasLimit || res?.effectiveGasPrice?._hex||res?.gasUsed) *
                Number(res?.gasPrice || res?.gasUsed?._hex||res?.maxFeePerGas)) /
                1000000000000000000
            ).toFixed(4)
          );
          axios
            .post(
              `${
                environmentVariables?.apiUrl
              }/nftmarketplace/api/v1/changestakingstatus/${nftAddress.toLowerCase()}/${tokenID}`,
              { isStaked: true }
            )
            .then(() => {
              setLoadingStake(false);
              setPerform("Staked");
              // setShowDepositPopup(true);
              triggerPusher(allContractDetails?.address);
              setShowCreatedPopup(true);
              setMessage("Your stake has been listed.");
              axios
                .get(
                  `${environmentVariables?.redisUrl}/nftmarketplace/api/v1/cleardata`
                )
                .then((res) => console.log(res))
                .catch((err) => console.log(err));
            })
            .catch((err) => {
              setLoadingStake(false);
              setPerform("Staked");
              // setShowDepositPopup(true);
              console.log(err);
              setMessage("Something went wrong");
              setIsListStakeError(true);
            });
        }
      })
      .catch((err) => {
        addErrorLogs("stakeNFT", JSON.stringify(err));
        setLoading(false);
        setMessage(
          err?.response?.data?.message || err?.message || "Something went wrong"
        );
        setIsListStakeError(true);
        setLoadingStake(false);
        // setShowCreatedPopup(true);
        // console.log(
        //   "err",
        //   err.error.data.message || err.message || "Something went wrong"
        // );
      });
  };
  const callNftListing = async () => {
    const res = await isSupportedNFT(
      allContractDetails?.metaspaceNFTMarketplaceContract,
      contractAdd
    );

    // console.log("res inside a callNftListing", res);
    if (res === true) {
      if (price > 0 && currency !== " ") {
        // For BigInt problem
        // console.log("res true and inside a if condition", currency, price);
        const updatedPrice = convertedMulPrice(currency, price);
        // console.log("updatedPrice", updatedPrice);
        // console.log("before listNft call");
        // console.log("address", address);
        // console.log("tokenId", tokenId);
        // console.log("currency", currency);
        // console.log(
        //   "updatedPrice.",
        //   parseInt(updatedPrice / 1000000000000000000)
        // );
        // console.log("auction", auction);

        // console.log(
        //   "before await listnft",
        //   allContractDetails?.metaspaceNFTMarketplaceContract,
        //   address
        // );
        const newPrice = BigInt(updatedPrice);
        await addInitiatedTransactions(contractAdd, tokenId, "list");
        await listNFT(
          allContractDetails?.metaspaceNFTMarketplaceContract,
          contractAdd,
          tokenId,
          currency,
          newPrice,
          auction
        )
          .then(async (res) => {
            // console.log(" inside then...", res);
            // console.log(
            //   (parseFloat(res?.gasLimit) * parseFloat(res?.gasPrice)) /
            //     1000000000000000000,
            //   "gasprice"
            // );
            console.log(res, "responseafterlisting");
            setTransactionHash(res?.hash);
            setTransactionFee(
              (
                (Number(res?.gasLimit || res?.gasUsed) * Number(res?.gasPrice||res?.maxFeePerGas)) /
                1000000000000000000
              ).toFixed(4)
            );
            if (res !== null) {
              //addpt: need to integrate listing api here and change the owner
              // console.log(" adding console in side ifff");
              axios
                .post(
                  `${
                    environmentVariables?.apiUrl
                  }/nftmarketplace/api/v1/update_listing_status/${contractAdd.toLowerCase()}/${tokenId}`,
                  {
                    currency: currency,
                    price: getConvertedCurrency(currency, updatedPrice),
                    isFixed: auction,
                  }
                )
                .then(() => {
                  // console.log("Apiresponse111111", Apiresponse);
                  axios
                    .get(
                      `${environmentVariables?.redisUrl}/nftmarketplace/api/v1/cleardata`
                    )
                    .then((res) => console.log(res))
                    .catch((err) => console.log(err));

                  setListPopUp(false);
                  setListingGas(null)
                  // setSuccess(true);
                  setLoadingList(false);
                  setMessage("Your Nft has been listed.");
                  // setShowCreatedPopup(true);
                  // setPrice("");
                  triggerPusher(allContractDetails?.address);
                  setOpen(false);
                  setShowDepositPopup(true);
                })
                .catch((error) => {
                  setLoadingList(false);
                  setOpen(false);
                  // setPrice("");
                  console.log(error)
                  setMessage("Something went wrong");
                  setIsListStakeError(true);

                  // console.log("error is here", error);
                });
            }
          })
          .catch((err) => {
            console.log(err);
            addErrorLogs("listNFT", JSON.stringify(err));
            setLoading(false);
            setLoadingList(false);
            setOpen(false);
            setMessage("Something went wrong");
            setIsListStakeError(true);
            // setShowCreatedPopup(true);
          });
      }
    }
  };

  const getPrice = () => {
    if (typeof apiData?.price == undefined) {
      return (
        <Text CommonPistol>
          {" "}
          Price :
          <TextValue>
            {apiData?.price && (
              <>
                0<Span>$MLD </Span>
              </>
            )}
          </TextValue>
        </Text>
      );
    } else if (typeof apiData?.price == "number") {
      return (
        <Text CommonPistol>
          {" "}
          Price :
          <TextValue>
            {apiData?.price && (
              <>
                {apiData?.price}
                <Span> {apiData?.currency=="MLD"?"$":""}{apiData?.currency} </Span>
              </>
            )}
          </TextValue>
        </Text>
      );
    } else if (typeof apiData?.price == "object") {
      return (
        <Text CommonPistol>
          {" "}
          Price :
          <TextValue>
            {apiData?.price && (
              <>
                {parseInt(apiData?.price / 1000000000000000000)}
                <Span> {getTradeCurrency(apiData?.tradeCurrency)} </Span>
              </>
            )}
          </TextValue>
        </Text>
      );
    }
  };
  const getTradeCurrency = (id) => {
    let answer = "";

    if (id === "0xc2132D05D31c914a87C6611C10748AEb04B58e8F") {
      answer = "USDT";
    }
    if (id === "0xca082498a1dE55c5d13C5AF2B10CA5e1957349E6") {
      answer = "MLD";
    }
    if (id === "0x0000000000000000000000000000000000001010") {
      answer = "MATIC";
    }

    return answer;
  };
  // console.log(
  //   data,
  //   data?.isListed,
  //   data?.isStaked,
  //   "listing and staking status"
  // );

  return (
    <>
      {loadingStake && <TransactionLoader />}
      {loadingList && <TransactionLoader />}
      {comingSoonPopup && <ComingSoon stakeConfirmPopup={comingSoonPopup} setStakeConfirmPopup={setComingSoonPopUp} isMLD={false}/>}
      <Root>
        <DialogStyledUpdate
          open={isListStakeError}
          onClose={() => setIsListStakeError(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          PaperProps={{
            sx: { overflow: "initial", backgroundColor: "transparent" },
          }}
        >
          <ButtonCancel
            onClick={() => setIsListStakeError(false)}
            color="primary"
          >
            X
          </ButtonCancel>
          <div className={classes.customButton}>
            {/* <DialogTitle id="alert-dialog-title"  style={{textAlign:"left", fontSize:"28px", fontWeight:"500", padding:"0"}}>
              Insufficient Balance 
              </DialogTitle> */}

            <NftNameConfirm>
              <NftNameConfirmHead>{message}</NftNameConfirmHead>
            </NftNameConfirm>

            {/* <NftAmountConfirmHeadPur>
                <NftAmountConfirmHead2>Transaction Fee :</NftAmountConfirmHead2>
                <NftAmountConfirmSubHead2>0.015 Matic</NftAmountConfirmSubHead2>
              </NftAmountConfirmHeadPur> */}
            {/* <DialogActions>
                <PayButtons>
                  
                  <ButtonConfirm onClick={handlePurchase} color="primary" autoFocus>
                    Confirm
                  </ButtonConfirm>
                </PayButtons>
              </DialogActions> */}
          </div>
        </DialogStyledUpdate>

        <Container>
          <DialogStyledUpdate
            open={lowBalancePopUp}
            onClose={() => setLowBalancePopup(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            PaperProps={{
              sx: { overflow: "initial", backgroundColor: "transparent" },
            }}
          >
            <ButtonCancel
              onClick={() => setLowBalancePopup(false)}
              color="primary"
            >
              X
            </ButtonCancel>
            <div className={classes.customButton}>
              {/* <DialogTitle id="alert-dialog-title"  style={{textAlign:"left", fontSize:"28px", fontWeight:"500", padding:"0"}}>
              Insufficient Balance 
              </DialogTitle> */}

              <NftNameConfirm>
                <NftNameConfirmHead>Insufficient Balance</NftNameConfirmHead>
              </NftNameConfirm>
            </div>
          </DialogStyledUpdate>
          <Wrapper>
            {nftloading ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CircularLoader />
              </div>
            ) : (
              <>
                <NameWrapper>
                  {/* <SubCategory>SubCategory</SubCategory> */}
                  <NameTextMain>
                    {/* <NftCategory>{fetchDetails.category}</NftCategory> */}
                    <NftCategoryHash>
                      <NftCategory common>
                        {fetchDetails?.category == "uncommon" ||
                        fetchDetails?.category == "Uncommon"
                          ? "rare"
                          : fetchDetails?.category}
                      </NftCategory>
                      <NftHash>
                        <LordImage src={HashImg}></LordImage>{" "}
                        {fetchDetails?.hash}
                      </NftHash>
                    </NftCategoryHash>
                    <NameText>{name}</NameText>
                    {/* <NameText>Fangs of Fury</NameText> */}
                    <CollectionText>
                      {/* <CollectionImg src={CollectionBoxImg}></CollectionImg> */}
                      {getCollectionImage(params?.contract)}
                      <CollectionTextFlex>
                        <CollectionTextHead>Collection</CollectionTextHead>

                        <CollectionTextName>
                          {params.contract ===
                          "0x8fc3dec6148a9924870f205617c9c26b3010243e"
                            ? "Shootable"
                            : params.contract ===
                                  "0x6b229c5687d00590606f97045ad65d8dfbfe1bdc" ||
                                params.contract ===
                                  "0x8a41c16ed29205383cf920b7bc50846852945202" ||
                                params.contract ===
                                  "0x6ab30d4c7de4a24cbe84eb310fd164b64b06b532"
                              ? "Melee"
                              : params.contract ===
                                  "0x7eb272ac9b9fec60c5a7921ccc075152a961111c"
                                ? "Characters"
                                : params.contract ===
                                    "0x69cc97aad84e5aebd72ec147d7b81b72e22c3ece"
                                  ? "Vehicle"
                                  : null}
                        </CollectionTextName>

                        {/* </CollectionTextName> */}
                      </CollectionTextFlex>
                    </CollectionText>
                  </NameTextMain>
                </NameWrapper>

                <TextWrapper>
                  {/* <Text> Sale ends May 19, 2023 at 4:34pm </Text> */}
                  {/* <Text CommonPistol> Rarity : {rarity || "Common"} </Text> */}
                  {getPrice()}
                </TextWrapper>
              </>
            )}

            <Modal
              aria-labelledby="modal-title"
              aria-describedby="modal-desc"
              open={open}
              onClose={() => setOpen(false)}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Sheet
                variant="outlined"
                sx={{
                  minWidth: 500,
                  borderRadius: "md",
                  p: 3,
                  boxShadow: "lg",
                }}
              >
                <ModalClose
                  variant="outlined"
                  sx={{
                    boxShadow: "0 2px 12px 0 rgba(0 0 0 / 0.2)",
                    borderRadius: "50%",
                    bgcolor: "background.body",
                  }}
                />
                <PopUpContainer>
                  {/* <LeftContainer>
                <ImageWrapper>
                </ImageWrapper>
              </LeftContainer> */}
                  <RightContainer>
                    <HeadingTextWrapper>
                      {/* <HeadingText> BuyNow</HeadingText>
                  <Paragrapgh>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor incididunt
                  </Paragrapgh> */}
                    </HeadingTextWrapper>
                    <NftNameContainer>
                      <NftNameWrapper>
                        {/* <NftNameVaue>Heavy Pistol</NftNameVaue>
                    <NftNameVaue> $20 </NftNameVaue> */}
                      </NftNameWrapper>
                      <NftNameWrapper>
                        {/* <NftNameVaue Common> Common </NftNameVaue>
                    <NftNameVaue Common> 1 item </NftNameVaue> */}
                      </NftNameWrapper>
                    </NftNameContainer>
                    {/* <Line /> */}

                    <TotalContainer>
                      <FloorDiscountContainer>
                        <Dropdown> Price: 20</Dropdown>
                      </FloorDiscountContainer>
                    </TotalContainer>

                    <DropdownContainer>
                      <DropDownTextWrapper>
                        <Dropdown>Currency : $MLD </Dropdown>
                        <SelectContainer>
                          {/* <Select>
                        <Option>Matic</Option>
                        <Option>MLD</Option>

                      </Select> */}
                        </SelectContainer>
                      </DropDownTextWrapper>
                      <ButtonWrapper2>
                        <Button2 onClick={() => setOpen(false)}>
                          Confirm
                        </Button2>
                      </ButtonWrapper2>
                    </DropdownContainer>
                  </RightContainer>
                </PopUpContainer>
              </Sheet>
            </Modal>
            <DialogStyledUpdate
              open={confirmOpen}
              onClose={() => setConfirmOpen(false)}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              PaperProps={{
                sx: { overflow: "initial", backgroundColor: "transparent" },
              }}
            >
              <ButtonCancel
                onClick={() => setConfirmOpen(false)}
                color="primary"
              >
                X
              </ButtonCancel>
              <div className={classes.customButton}>
                <DialogTitle
                  id="alert-dialog-title"
                  style={{
                    textAlign: "left",
                    fontSize: "28px",
                    fontWeight: "500",
                    padding: "0",
                  }}
                >
                  Confirm Purchase
                </DialogTitle>
                <DialogContent style={{ padding: "0 0 40px" }}>
                  <DialogContentText
                    id="alert-dialog-description"
                    style={{
                      textAlign: "left",
                      color: "#bbb",
                      fontSize: "16px",
                    }}
                  >
                    Please verify this information to complete the transaction
                  </DialogContentText>
                </DialogContent>
                <NftNameConfirm>
                  {/* <NftConfirmImg src={NftConfirmImg2}></NftConfirmImg> */}
                  <NameandcategoriesWrapper>
                    <NftNameConfirmHead>{name}</NftNameConfirmHead>
                    <NftNameConfirmSubHead>
                      {fetchDetails?.category == "uncommon" ||
                      fetchDetails?.category == "Uncommon"
                        ? "rare"
                        : fetchDetails?.category}
                    </NftNameConfirmSubHead>
                  </NameandcategoriesWrapper>
                  <NftNameConfirmHash># {apiData?.hash}</NftNameConfirmHash>
                </NftNameConfirm>
                <NftAmountConfirm>
                  <NftAmountConfirmHead>Amount :</NftAmountConfirmHead>
                  <NftAmountConfirmSubHead>
                    {apiData?.price && (
                      <>
                        {parseInt(apiData?.price / 1000000000000000000)}
                        <Span>
                          {" "}
                          {getTradeCurrency(apiData?.tradeCurrency) == "MLD" ||
                          getTradeCurrency(apiData?.tradeCurrency) == "LORD"
                            ? "$"
                            : ""}
                          {getTradeCurrency(apiData?.tradeCurrency)}{" "}
                        </Span>
                      </>
                    )}
                  </NftAmountConfirmSubHead>
                </NftAmountConfirm>
                <NftAmountConfirmHeadPur>
                  <NftAmountConfirmHead2>
                    Transaction Fee :
                  </NftAmountConfirmHead2>
                  <NftAmountConfirmSubHead2>
                    {gasStake !== null || gasStake !== undefined
                      ? `${gasStake.toFixed(4)} POL`
                      : "Cannot estimate fees, transaction may fail!"}
                  </NftAmountConfirmSubHead2>
                </NftAmountConfirmHeadPur>
                <DialogActions>
                  <PayButtons>
                    <ButtonConfirm color="primary" autoFocus>
                      Confirm
                    </ButtonConfirm>
                  </PayButtons>
                </DialogActions>
              </div>
            </DialogStyledUpdate>

            <>
              {data?.isStaked == true && (
                <ButtonWrapper>
                  <Button style={{ cursor: "default" }} disabled={true}>
                    Already Staked
                  </Button>
                </ButtonWrapper>
              )}
              {data?.isListed == true && (
                <ButtonWrapper>
                  <Button style={{ cursor: "default" }} disabled={true}>
                    Already Listed
                  </Button>
                </ButtonWrapper>
              )}
              {data.isListed != true && data?.isStaked != true && (
                <>
                  <ButtonWrapper>
                    <Button
                      onClick={() => {
                        handleList()
                      }}
                      // disabled={data?.tradeCurrency && data?.price ? false : true}
                    >
                      {loadingBtn ? (
                        <>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              border: "none !important",
                            }}
                          >
                            <CircularLoader />
                          </div>
                        </>
                      ) : (
                        "List"
                      )}
                      {/* <SubButton>( List your NFT into Marketplace )</SubButton> */}
                    </Button>
                    <Button
                      whiteback
                      onClick={approvePopUpForStaking==true?()=>setApproveStakingPopUpOpen(true):handleStake}
                      // disabled={data?.tradeCurrency && data?.price ? false : true}
                    >
                      {stakeBtnSubmit ? (
                        <>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              border: "none !important",
                            }}
                          >
                            <CircularLoader />
                          </div>
                        </>
                      ) : (
                        "Stake"
                      )}
                      {/* <SubButton>( Stake your NFT into Marketplace )</SubButton> */}
                    </Button>
                  </ButtonWrapper>
                </>
              )}
            </>
          </Wrapper>
        </Container>

        <LowBalancePopUp
          message={"Insufficient Lords"}
          currency={"LORD"}
          isStakeError={isStakeError}
          setIsStakeError={setIsStakeError}
        />

        <Dialog
          open={stakeConfirmPopup}
          onClose={() => setStakeConfirmPopup(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          PaperProps={{
            sx: { overflow: "initial", backgroundColor: "transparent" },
          }}
        >
          <ButtonCancel
            onClick={() => setStakeConfirmPopup(false)}
            color="primary"
          >
            X
          </ButtonCancel>
          <div className={classes.customButton}>
            <DialogTitle
              id="alert-dialog-title"
              style={{
                textAlign: "left",
                fontSize: "28px",
                fontWeight: "500",
                padding: "0",
              }}
            >
              Lock in your NFT Stake
            </DialogTitle>
            <DialogContent style={{ padding: "0 0 40px" }}>
              <DialogContentText
                id="alert-dialog-description"
                style={{
                  textAlign: "left",
                  color: "#bbb",
                  fontSize: "16px",
                }}
              >
                Double-check your details to complete the transaction
              </DialogContentText>
            </DialogContent>

            <NftNameConfirm>
              <NftNameConfirmHead>{fetchDetails?.name}</NftNameConfirmHead>
              <NftNameConfirmHeadHash>
                # {fetchDetails?.hash}
              </NftNameConfirmHeadHash>
            </NftNameConfirm>

            <NftAmountConfirmHeadPur>
              <NftAmountConfirmHead2>Lord Required :</NftAmountConfirmHead2>
              <NftAmountConfirmSubHead3>10 $LORD</NftAmountConfirmSubHead3>
            </NftAmountConfirmHeadPur>
            {/* <NftAmountConfirmHeadPur>
              <NftAmountConfirmHead2>Reward Earned/Day:</NftAmountConfirmHead2>
              <NftAmountConfirmSubHead3>3 Months</NftAmountConfirmSubHead3>
            </NftAmountConfirmHeadPur> */}
            <NftAmountConfirmHeadPur>
              <NftAmountConfirmHead2>Transaction Fee :</NftAmountConfirmHead2>
              <NftAmountConfirmSubHead3>
                {gasStake
                  ? `${gasStake && gasStake.toFixed(6)} POL`
                  : "0.02951 POL"}
              </NftAmountConfirmSubHead3>
            </NftAmountConfirmHeadPur>
            <DialogActions>
              <PayButtons>
                <ButtonConfirm
                  onClick={() => {
                    stake(contractAdd, tokenId);
                    setStakeConfirmPopup(false);
                  }}
                  color="primary"
                  autoFocus
                >
                  Confirm
                </ButtonConfirm>
              </PayButtons>
            </DialogActions>
          </div>
        </Dialog>
        <Modal
          aria-labelledby="modal-title"
          aria-describedby="modal-desc"
          open={approveStakingPopUpOpen}
          onClose={() => {
            setApproveStakingPopUpOpen(false);
            setMessage("");
          }}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            // backgroundColor: "#2a2a2a !important",
            backgroundColor: "#00000080 !important",
            color: "#fff ",
          }}
        >
          <Sheet
            variant="outlined"
            sx={{
              width: 600,
              borderRadius: "md",
              p: 3,
              boxShadow: "lg",
              backgroundColor: "#2a2a2a",
              border: "1px solid #484848",
              padding: "50px",
            }}
          >
           
              <TextContractContainer>
                <ContractTextWrapper>
                  <ContractText>Approve NFT for Staking </ContractText>
                </ContractTextWrapper>
              </TextContractContainer>

              <TextContractContainer>
                <p   style={{
                        color: "#eeeeee",
                        fontWeight: "400",
                        fontSize: "14px",
                      }}>
                  To stake your NFT, you must first approve the staking contract
                  to use your <span style={{ fontWeight: "600" }}>LORD tokens</span>.
                </p>


                <p   style={{
                        color: "#eeeeee",
                        fontWeight: "400",
                        fontSize: "14px",
                      }}>
                  This approval is only required once. After that, you can stake
                  multiple NFTs without repeating this step.
                </p>

                <p style={{
                        color: "#ffffff",
                        fontWeight: "700",
                        fontSize: "14px",
                      }}>
                  <span style={{ fontWeight: "600" }}>Note:</span> A minimum of{" "}
                  <span style={{ fontWeight: "600" }}>10 LORD tokens</span> is required in your wallet to
                  proceed with staking.
                </p>
                <p style={{
                        color: "#ffffff",
                        fontWeight: "700",
                        fontSize: "14px",
                      }}>
                 Approval may require a small amount of POL as gas fee.
                </p>
              </TextContractContainer>
              <ButtonWrapper>
                <PopupButton
                  
                  onClick={() => {

                   
                      handleApproveNFTForStaking();
                    
                  }}
                >
                  { approveLoading ? (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <CircularLoader />
                    </div>
                  ) : 
                    `Approve `
                }
                </PopupButton>
              </ButtonWrapper>        
          </Sheet>
        </Modal>
        <Modal
          aria-labelledby="modal-title"
          aria-describedby="modal-desc"
          open={listPopUp}
          onClose={() => {
            setListPopUp(false);
            setPrice("");
            setMessage("");
            setLoadingBtn(false);
            setListingGas(null);
          }}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            // backgroundColor: "#2a2a2a !important",
            backgroundColor: "#00000080 !important",
            color: "#fff ",
          }}
        >
          <Sheet
            variant="outlined"
            sx={{
              width: 600,
              borderRadius: "md",
              p: 3,
              boxShadow: "lg",
              backgroundColor: "#2a2a2a",
              border: "1px solid #484848",
              padding: "50px",
            }}
          >
            <ModalClose
              variant="outlined"
              sx={{
                top: "calc(-1/4 * var(--IconButton-size))",
                right: "calc(-1/4 * var(--IconButton-size))",
                boxShadow: "0 2px 12px 0 rgba(0 0 0 / 0.2)",
                borderRadius: "50%",
                bgcolor: "background.body",
              }}
            />

            <>
              {approvePopUP == true ? (
                <>
                  <TextContractContainer>
                    <ContractTextWrapper>
                      <ContractText>Approve NFT for Listing </ContractText>
                    </ContractTextWrapper>
                  </TextContractContainer>

                  <TextContractContainer>
                    <p
                      style={{
                        color: "#eeeeee",
                        fontWeight: "400",
                        fontSize: "14px",
                      }}
                    >
                      Before you can list your{" "}
                      <span style={{ fontWeight: "600" }}>Shootable</span>,{" "}
                      <span style={{ fontWeight: "600" }}>Melee</span>, or{" "}
                      <span style={{ fontWeight: "600" }}>Character</span> NFTs
                      for the first time, you need to approve them for listing.
                    </p>

                    <p
                      style={{
                        color: "#eeeeee",
                        fontWeight: "400",
                        fontSize: "14px",
                      }}
                    >
                      This is a one-time approval required for each NFT type.
                      Once approved, you can list as many NFTs of the same type
                      without repeating this step.
                    </p>

                    <p
                      style={{
                        color: "#ffffff",
                        fontWeight: "700",
                        fontSize: "14px",
                      }}
                    >
                      Please note: Approving NFTs may cost a small amount of
                      POL (gas fee).
                    </p>
                  </TextContractContainer>
                </>
              ) : (
                <>
                  <TextContractContainer>
                    <ContractTextWrapper>
                      <ContractText>Set NFT Price </ContractText>
                    </ContractTextWrapper>
                    <PopUpTextWrapper>
                      <PopupText
                        disabled={approvePopUP}
                        type="number"
                        placeholder="List Price"
                        value={price}
                        onKeyDown={(e) => {
                          if (e.key == "-") {
                            setListBtnDisable(true);
                            e.preventDefault();
                          } else if (e.key == "+") {
                            setListBtnDisable(true);
                            e.preventDefault();
                          }
                        }}
                        onChange={(e) => {
                          const value = e.target.value;
                          const regex = /^\d*\.?\d{0,2}$/;
                          if (regex.test(value)) {
                            if (e.target.value > 0 && currency != "") {
                              setPrice(e.target.value);
                              // setListBtnDisable(false);
                            } else {
                              // setListBtnDisable(true);
                              setPrice(null);
                              e.preventDefault();
                            }
                            handleListNFT(e);
                            const inputValue = e.target.value;
                            const sanitizedValue = inputValue.replace(/^-/, "");
                            setPrice(sanitizedValue);
                          }
                        }}
                      />
                    </PopUpTextWrapper>
                  </TextContractContainer>

                  <TextContractContainer>
                    <ContractTextWrapper>
                      <ContractText>Set Currency </ContractText>
                      <BalanceText>{`Bal: ${Number(userBalance?.MLDBalanceDec).toFixed(2)} MLD`}</BalanceText>
                    </ContractTextWrapper>
                    <SelectWrapper>
                      <Select
                        disabled={approvePopUP}
                        onChange={(e) => {
                          // setCurrency(e.target.value);
                          if (e.target.value == "" || price <= 0) {
                            e.preventDefault();
                            // setListBtnDisable(true);
                          } else {
                            // setListBtnDisable(false);
                          }
                          const selectedIndex = e.target.selectedIndex;
                          const selectedOptionText =
                            e.target.options[selectedIndex].textContent=="$MLD"?"MLD":e.target.options[selectedIndex].textContent;
                          setCurrency(selectedOptionText);
                          handleListNFT(e);
                        }}
                      >
                        <Option value="">Select Currency</Option>
                        <Option value="0x0000000000000000000000000000000000001010">
                          POL
                        </Option>
                        <Option value="0xc2132D05D31c914a87C6611C10748AEb04B58e8F">
                          USDT
                        </Option>
                        <Option
                          selected
                          value="0xca082498a1dE55c5d13C5AF2B10CA5e1957349E6"
                        >
                          $MLD
                        </Option>
                      </Select>
                    </SelectWrapper>
                  </TextContractContainer>
                </>
              )}
              {listingGas > 0 ? (
                <>
                 <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                   <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <div style={{ color: "#bbbbbb",marginRight:"3px" }}>{`Transaction Fees:- `}</div>
                    <div style={{ color: "#bbbbbb" }}>
                      {listingGas
                        ? ` ${listingGas.toFixed(4)} POL`
                        : " 0.02585 POL"}
                    </div>
                  </div>
                   <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <div style={{ color: "#bbbbbb",marginRight:"3px" }}>{`Avl Bal: `}</div>
                    <div style={{ color: "#bbbbbb" }}>
                      {` ${Number(userBalance?.MATIC).toFixed(4)} POL`}
                    </div>
                  </div>
                 </div>
                </>
              ) : (
                <></>
              )}
              {message && (
                <>
                  <div style={{ color: "red" }}>{message}</div>
                </>
              )}
              <ButtonWrapper>
                <PopupButton
                  disabled={listBtnDisable}
                  style={
                    listBtnDisable
                      ? { cursor: "default", background: "grey" }
                      : {
                          cursor: "pointer",
                          background:
                            "linear-gradient(45deg, #0a5d6e, #00aacd)",
                        }
                  }
                  onClick={() => {
                    // console.log(
                    //   "adddress, tokenId, auction",
                    //   address,
                    //   tokenId,
                    //   auction,
                    //   price,
                    //   currency
                    // );
                    if (approvePopUP) {
                      handleApproveNFT();
                    } else {
                      onConfirmClick();
                    }
                  }}
                >
                  {loadingList || approveLoading ? (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <CircularLoader />
                    </div>
                  ) : approvePopUP ? (
                    `Approve `
                  ) : (
                    `Confirm `
                  )}
                </PopupButton>
              </ButtonWrapper>
            </>
          </Sheet>
        </Modal>
        {showDepositPopup && (
          <ConfirmPopup
            popUpText={`NFT Listed on Marketplace`}
            fullwidth={true}
            showPopup={showDepositPopup}
            setShowPopup={setShowDepositPopup}
            fetchDetails={fetchDetails}
            transactionHash={transactionHash}
            transactionFee={transactionFee}
            isList={true}
            onClickFun={() => {
              setShowDepositPopup(false);
              navigation("/mynfts");
            }}
            text={`Success`}
            price={price}
            currency={currency}
            setPrice={setPrice}
          ></ConfirmPopup>
        )}
        {showCreatedPopup && (
          <ConfirmPopup
            popUpText={`NFT Staked on Marketplace`}
            fullwidth={true}
            showPopup={showCreatedPopup}
            setShowPopup={setShowCreatedPopup}
            fetchDetails={fetchDetails}
            transactionHash={transactionHash}
            transactionFee={transactionFee}
            isList={true}
            onClickFun={() => {
              setShowDepositPopup(false);
              navigation("/mynfts");
            }}
            text={`Success`}
            price={price || apiData?.price}
            currency={currency || apiData?.currency}
            setPrice={setPrice}
          ></ConfirmPopup>
        )}
      </Root>
    </>
  );
};


const useStyles = makeStyles(() => ({
  customButton: {
    padding: "50px",
    backgroundColor: "#2a2a2a",
    border: "1px solid #484848",
    borderRadius: "10px",
    color: "#fff",
    minWidth: "360px",
    "@media (max-width: 768px)": {
      minWidth: "360px",
    },
    "@media (max-width: 600px)": {
      maxWidth: "220px",
      minWidth: "350px",
      padding: "40px 30px",
      backgroundColortransparent: true,
    },
    "@media (max-width: 400px)": {
      maxWidth: "220px",
      minWidth: "320px",
      padding: "40px 30px",
      backgroundColortransparent: true,
    },
  },
}));


const Root = styled.div`
  width: 100%;
  /* margin: 0 20px; */
  @media (max-width: 1024px) {
    /* padding: 0 20px; */
    width: 100%;
  }
  @media (max-width: 650px) {
    padding: 0;
  }
`;
const Container = styled.div`
  /* margin-top: 120px;
  @media(max-width:1440px){
    margin-top:80px ;
  }
  @media (max-width: 1260px) {
    margin-top: 40px;
  }
  @media (max-width: 1024px) {
    margin-top: 30px;
  } */
`;
const TextContractContainer = styled.div`
  margin: 1.5rem 0;
`;
const ContractTextWrapper = styled.div`
  margin: 10px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const BalanceText = styled.div`
color: #fff;
font-size: 16px;
font-weight: 500;
`

const ContractText = styled.text`
  font-size: 24px;
  font-family: sans-serif;
  font-weight: 500;
  color: #fff;
`;
const NftNameConfirmHeadHash = styled.div`
  font-size: 18px;
  font-weight: 800;
  background: -webkit-linear-gradient(0deg, #facf49, #fb7111);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  color: #c95e73;
  text-transform: uppercase;
  background-color: #171e22;
  padding: 5px 20px;
  border-radius: 50px;
  position: relative;
  border: 1px solid #31393c;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  max-height: 35px;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  /* width: 105px; */
`;
const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  text-align: right;
  width: 100%;
  flex-direction: column;
  background-color: #151a1c;
  /* background: linear-gradient(
      180deg,
      rgba(249, 249, 249, 0.04) 0%,
      rgba(249, 249, 249, 0.04) 100%
    ); */
  /* border-width: 1px 0px;
    border-style: solid;
    border-color: rgba(255, 255, 255, 0.4);
    box-shadow: 0px 19px 46px rgba(0, 0, 0, 0.12); */
  border-radius: 10px;
  padding: 30px;
  @media (max-width: 1024px) {
    padding: 20px 30px;
  }
  @media (max-width: 1024px) {
    padding: 20px 30px;
  }
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-top: 30px;
`;
const Text = styled.text`
  font-family: sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  margin: 10px 0;
  color: #6a6a6a;
  ${(p) =>
    p.CommonPistol &&
    `
line-height: 10px;
color: #6a6a6a;
margin-bottom:15px;
font-size: 16px;
font-weight:600;
display:flex;
align-items: flex-start;
flex-direction: column;
`}
`;

const NftNameConfirmHead = styled.div`
  font-size: 24px;
  font-weight: 600;
`;
const NftAmountConfirmHeadPur = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
`;
const NftAmountConfirmHead2 = styled.div`
  font-size: 16px;
  color: #bbb;
`;
const NftAmountConfirmSubHead2 = styled.div`
  font-size: 16px;
  color: #bbb;
`;
const NftNameConfirm = styled.div`
  display: flex;
  align-items: center;
  padding-bottom: 20px;
  padding-top: 20px;
  border-bottom: 1px solid #484848;
  border-top: 1px solid #484848;
  justify-content: center;
`;
const TextValue = styled.div`
  font-weight: 700;
  font-size: 40px;
  line-height: 38px;
  color: #f3f3f3;
  padding-top: 10px;
`;

const Span = styled.span`
  color: #9b9b9b;
  font-size: 16px;
`;

const ButtonWrapper = styled.div`
  width: 100%;
`;

const ButtonCancel = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: -15px;
  right: -20px;
  background-color: #b3b3b3;
  border-radius: 50px;
  outline: none;
  border: none;
  font-size: 20px;
  /* font-weight: 600; */
  padding: 20px;
  margin: 0;
  cursor: pointer;
  color: #000;
  width: 45px;
  height: 45px;
  transition: 1s;
  @media (max-width: 768px) {
    margin: 5px 0;
    top: -25px;
    right: -15px;
  }
  /* &:hover {
    background: linear-gradient(45deg, #fff, #d3d3d3);
    color: #151a1c;
  } */
`;
const ButtonConfirm = styled.button`
  background: linear-gradient(45deg, #0a5d6e, #00aacd);
  border-radius: 50px;
  outline: none;
  border: none;
  font-size: 24px;
  padding: 20px 80px;
  margin: 40px 0 10px;
  cursor: pointer;
  color: #e9e9e9;
  width: 100%;
  transition: 1s;
  @media (max-width: 768px) {
    margin: 5px 0;
  }
  /* &:hover {
    background: linear-gradient(45deg, #fff, #d3d3d3);
    color: #151a1c;
  } */
`;
const Button = styled.button`
  /* background: linear-gradient(45deg, #1a6d7e, #04a1c1); */
  background-color: #151a1c;
  border-radius: 50px;
  border: 1px solid #ffffff47;
  outline: none;
  font-size: 18px;
  padding: 17px 80px;
  margin: 15px 0;
  cursor: pointer;
  color: #fff;
  width: 100%;
  transition: 1s;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 22px;
  font-weight: 500;
  text-transform: uppercase;
  @media (max-width: 768px) {
    margin: 5px 0;
  }
  &:hover {
    /* background: linear-gradient(45deg, #fff, #d3d3d3); */
    /* color: #151a1c; */
  }
  ${(p) =>
    p.whiteback &&
    `
    background-color: #ffffff;
    color: #535353;
  `};
`;

const PopUpContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  background: #181718;
  border-radius: 15px;
  /* text-align:center; */
`;
const RightContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px 80px;

  @media (max-width: 1024px) {
    padding: 20px 30px;
  }

  @media (max-width: 930px) {
    padding: 20px 15px;
  }
  @media (max-width: 550px) {
    padding: 20px 55px;
  }
  @media (max-width: 425px) {
    padding: 20px 75px;
  }
`;
const HeadingTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  color: white;
  width: 80%;
  margin: 20px 0;
`;

const NftNameContainer = styled.div`
  margin: 5px 0 30px 0;
`;
const NftNameWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

const TotalContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
`;
const FloorDiscountContainer = styled.div``;
const DropdownContainer = styled.div``;
const DropDownTextWrapper = styled.div`
  display: flex;
`;
const Dropdown = styled.div`
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
  font-family: sans-serif;
  color: #ffffff;
`;
const ButtonWrapper2 = styled.div`
  margin: 30px 0;
  width: 100%;
`;
const Button2 = styled.button`
  color: #88fefe;
  background: #203736;
  width: 100%;
  padding: 18px;
  border-radius: 30px;
  font-size: 18px;
  outline: none;
  border: none;
  cursor: pointer;
`;

const SelectContainer = styled.div``;
const Select = styled.select`
  margin: 0;
  width: 100%;
  padding: 15px 20px;
  font-size: 18px;
  border-radius: 50px;
  cursor: pointer;
  border: none;
  outline: none;
  color: #000;
`;
const Option = styled.option`
  cursor: pointer;
`;

const NameWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  text-align: center;
  justify-content: flex-start;
  flex-direction: column;
  padding: 0 0 30px 0px;
  border-bottom: 1px solid #2a2a2a;
  padding-bottom: 30px;
  width: 100%;
`;
const NameText = styled.text`
  font-size: 46px;
  font-weight: 600;
  text-transform: capitalize;
  text-align: left;
`;
const NameTextMain = styled.text`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
`;

const NftCategory = styled.div`
  font-size: 14px;
  font-weight: 800;
  color: #490d81;
  text-transform: uppercase;
  background-color: #d3b1f3;
  padding: 10px 30px;
  border-radius: 50px;
  position: relative;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  ${(p) =>
    p.rare &&
    `
    background-color: #22363e;
    color: #74bccb;
  `};
  ${(p) =>
    p.common &&
    `
    background-color: #dddddd;
    color: #535353;
  `};
`;

const CollectionText = styled.div`
  display: flex;
  padding-top: 20px;
  align-items: center;
`;
const PayButtons = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const CollectionTextHead = styled.div`
  font-size: 16px;
  color: #6a6a6a;
  font-weight: 600;
`;

const CollectionTextName = styled.div`
  font-size: 22px;
  color: #dfdfdf;
`;

const CollectionTextFlex = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-left: 10px;
`;

const CollectionImg = styled.img`
  width: 60px;
  height: 60px;
  background-color: #000;
  /* background-color: #137d92; */
  border-radius: 10px;
`;

const NftCategoryHash = styled.div`
  display: flex;
`;

const NftHash = styled.div`
  background: -webkit-linear-gradient(0deg, #facf49, #fb7111);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 18px;
  font-weight: 800;
  background: -webkit-linear-gradient(0deg, #facf49, #fb7111);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  color: #c95e73;
  text-transform: uppercase;
  background-color: #171e22;
  padding: 5px 20px;
  border-radius: 50px;
  position: relative;
  margin-bottom: 10px;
  margin-left: 10px;
  border: 1px solid #31393c;
  display: flex;
  align-items: center;
`;

const LordImage = styled.img`
  width: 25px;
  margin-right: 10px;
`;


const PopUpTextWrapper = styled.div`
  width: 100%;
`;
const PopupText = styled.input`
  width: 100%;
  padding: 15px 20px;
  font-size: 18px;
  border-radius: 50px;
  /* cursor: pointer; */
  border: none;
  outline: none;
  color: #000;
`;
const SelectWrapper = styled.div``;
// const Select = styled.select`
//   width: 100%;
//   font-size: 16px;
//   padding: 15px;
//   background-color: rgba(255, 255, 255, 0.1);
//   border-radius: 8px;

//   cursor: pointer;
//   outline: none;
// `;

// const Option = styled.option`
//   width: 80%;
//   font-size: 16px;
//   padding: 15px 10px !important;
//   background-color: rgba(255, 255, 255, 0.1);
//   color: Black !important;
//   border-radius: 8px;

//   cursor: pointer !important;
//   outline: none;
// `;

const PopupButton = styled(Button)`
  background: linear-gradient(45deg, #0a5d6e, #00aacd);
  border-radius: 50px;
  outline: none;
  border: none;
  font-size: 24px;
  padding: 20px 80px;
  margin: 40px 0 10px;
  cursor: pointer;
  color: #e9e9e9;
  width: 100%;
  -webkit-transition: 1s;
  transition: 1s;
`;





const NftAmountConfirmSubHead3 = styled.div`
  font-size: 16px;
  color: #fff;
`;



const NftNameConfirmSubHead = styled.div`
  font-size: 16px;
  color: #bbb;
  text-transform: capitalize;
`;
const NftAmountConfirm = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 30px 0 0;
`;

const NftAmountConfirmHead = styled.div`
  font-size: 24px;
`;
const NftAmountConfirmSubHead = styled.div`
  font-size: 24px;
`;

const NftNameConfirmHash = styled.div`
  background: -webkit-linear-gradient(0deg, #facf49, #fb7111);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 18px;
  font-weight: 800;
  background: -webkit-linear-gradient(0deg, #facf49, #fb7111);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  color: #c95e73;
  text-transform: uppercase;
  background-color: #171e22;
  padding: 5px 20px;
  border-radius: 50px;
  position: relative;
  margin-bottom: 10px;
  margin-left: 10px;
  border: 1px solid #31393c;
  display: flex;
  align-items: center;
  max-height: 35px;
  justify-content: space-between;
  width: 105px;
`;

const NameandcategoriesWrapper = styled.div`
  // margin: 0 0 0 20px;
`;

const DialogStyledUpdate = styled(Dialog)``;



export default NFTStakeandListPage;
